import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["amountInput", "submitBtn", "amountHint"]
  static values = { minAmount: Number }

  validate() {
    const value = this.amountInputTarget.value
    const invalid = !value || parseFloat(value) < this.minAmountValue

    this.submitBtnTarget.disabled = invalid
    this.amountHintTarget.classList.toggle('text-danger', invalid)
    this.amountHintTarget.classList.toggle('text-muted', !invalid)
  }
}
